var _a;
export const isMac = (((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.platform) || "")
    .substring(0, 3)
    .toLocaleLowerCase()
    === "mac";
